const IS_BROWSER = typeof window === 'object';

class ApplicationStore {
    width = IS_BROWSER ? window.innerWidth : 0;

    scroll = {
        vertical: IS_BROWSER ? window.scrollY : 0,
        horizontal: IS_BROWSER ? window.scrollX : 0,
        direction: 'none',
    };

    get isMobile() {
        return this.isPhone;
    }

    get isPhone() {
        return IS_BROWSER ? window.innerWidth < 768 : this.width < 768;
    }
}

const applicationContainer = new ApplicationStore();
export { IS_BROWSER, ApplicationStore, applicationContainer, applicationContainer as application };
export default applicationContainer;
